import React, {FC} from 'react';
import {LuCrown} from 'react-icons/lu';
import {isMasterFirebaseUser} from '../../../../library/GeneralUse';

const style = {
	container: `px-1 py-1 recommended:px-4    text-whirlwindLightest hover:text-whirlwindLight   bg-whirlwindPrimary hover:bg-whirlwindPrimaryDark   opacity-90`,
	userDisplayContainer: `flex flex-row justify-center items-center gap-x-1   break-all`,
};

type UserDisplayProps = {
	uid: string;
	username: string;
};

export const UserDisplay: FC<UserDisplayProps> = ({uid, username}) => {
	return (
		<div className={style.container}>
			<div className={style.userDisplayContainer}>
				<span>{username}</span>
				{isMasterFirebaseUser(uid) ? <LuCrown size={25} /> : <></>}
			</div>
		</div>
	);
};
